
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.193 3.463A.75.75 0 0020.5 3h-2.852a4.484 4.484 0 00-7.052-.943A4.46 4.46 0 009.25 5.25v.573C5.434 4.83 2.313 1.753 2.28 1.72a.75.75 0 00-1.268.397C.19 6.64 1.55 9.669 2.834 11.413c.646.88 1.429 1.65 2.318 2.284-1.43 1.617-3.641 2.466-3.665 2.476a.75.75 0 00-.36 1.118c.069.105.35.474 1.038.817.851.426 1.973.642 3.335.642 6.613 0 12.138-5.09 12.703-11.642L21.03 4.28a.75.75 0 00.163-.817zm-4.248 2.781a.75.75 0 00-.218.483C16.351 12.627 11.42 17.25 5.5 17.25c-.99 0-1.692-.131-2.177-.289 1.08-.586 2.584-1.594 3.551-3.045a.752.752 0 00-.286-1.086c-.014-.007-1.4-.724-2.588-2.363-1.351-1.865-1.92-4.121-1.696-6.722C3.784 4.959 6.62 6.947 9.875 7.49a.75.75 0 00.874-.74l.001-1.5a3.03 3.03 0 013.038-3 3.006 3.006 0 012.713 1.8.75.75 0 00.687.45h1.501l-1.744 1.744z","fill":"#42A5F5"}})])
          )
        }
      }
    